import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash.isempty';
import './style/Dialog.css';
import API from '../api/api';

class CreateBookingDialog extends React.Component {
    static propTypes = {
        config: PropTypes.object,
        boat: PropTypes.string,
        date: PropTypes.object,
        slot: PropTypes.string,
        onClose: PropTypes.func
    }
    state = {
        code: '',
        acceptTerms: false
    }
    render() {
        let submitEnabled = !isEmpty(this.state.code) && this.state.acceptTerms;
        return (
            <div className="dialog-container">
                <div className="dialog">
                    <div className="dialog-title">Prenotazione</div>
                    <div className="dialog-body">
                        <form action="" onSubmit={this.submit}>
                            <table><tbody>
                                <tr>
                                    <td>Barca:</td>
                                    <td><input type="text" disabled={true} defaultValue={this.props.config.boats[this.props.boat]} /></td>
                                </tr>
                                <tr>
                                    <td>Data:</td>
                                    <td><input type="text" disabled={true} defaultValue={this.props.date.format("DD.MM.YYYY")} /></td>
                                </tr>
                                <tr>
                                    <td>Fascia:</td>
                                    <td><input type="text" disabled={true} defaultValue={this.props.config.daySlots[this.props.slot]} /></td>
                                </tr>
                                <tr>
                                    <td>ID:</td>
                                    <td><input type="text" placeholder={"Indicato sulla tessera membro"} value={this.state.code} onChange={ev => this.setState({code: ev.target.value.toLowerCase()})} /></td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <label><input type="checkbox" value={this.state.acceptTerms} onChange={ev => this.setState({acceptTerms: ev.target.checked})} /> Ho letto e accetto le&nbsp;<a href="Condizioni_utilizzo_natanti.pdf" target="_blank">condizioni d'utilizzo</a></label>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan="2">
                                        <div className="dialog-buttonbar">
                                            <button type="submit" className="button-important" disabled={!submitEnabled}>Prenota</button>
                                            <button type="button" onClick={ev => this.props.onClose()}>Annulla</button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody></table>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
    submit = (ev) => {
        ev.preventDefault();
        API.createBooking(this.props.boat, this.props.date, this.props.slot, this.state.code, (success, data) => {
            if(success) {
                this.props.onClose(true);
            } else {
                alert(data);
            }
        });
    }
};

export default CreateBookingDialog;
